/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc15abef59e285d9030c58a432146de9>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "AlignContentLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-content-left
 * Usage guidance:
 * Used for aligning left edges of content in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const AlignContentLeftIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "AlignContentLeftIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 0v16H0V0zM3 4.38C3 3.62 3.62 3 4.38 3h9.25c.76 0 1.37.62 1.37 1.38v1.5c0 .76-.62 1.38-1.37 1.38H4.38C3.62 7.25 3 6.63 3 5.88zm1.5.13v1.25h9V4.5zM3 10.13c0-.76.62-1.37 1.38-1.37h4.25c.76 0 1.38.62 1.38 1.38v1.5C10 12.39 9.38 13 8.63 13H4.38C3.62 13 3 12.38 3 11.63zm1.5.13v1.25h4v-1.25z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
AlignContentLeftIcon.displayName = 'AlignContentLeftIcon';
var _default = exports.default = AlignContentLeftIcon;